if (!customElements.get('ups-compat-variant')) {
  customElements.define(
    'ups-compat-variant',
    class UpsCompatVariant extends HTMLElement {
      connectedCallback() {
        this.panels = this.querySelectorAll('.ups-compat__panel');
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
      }

      handleVariantChange({ data: { variant } }) {
        if (!variant) return;
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.variantTitle !== variant.title;
        });
      }
    }
  );
}
